<template lang="html">
  <div class="">
    <v-container grid-list-md>
      <v-layout wrap>
        <v-flex
          xs12
          md8
        >
          <v-layout
            row
            wrap
          >
            <v-flex xs12>
              <v-layout
                align-center
                mb-3
              >
                <v-flex shrink>
                  <SiConditionEditor
                    v-model="field.condition"
                    :title="`<strong>${field.name}</strong> condition`"
                    :fields="fields"
                    :field-id="field.name"
                    @change="save"
                  >
                    <template
                      v-if="!field.condition"
                      #activator="{ on }"
                    >
                      <v-btn
                        text
                        color="grey"
                        v-on="on"
                      >
                        <v-icon left>
                          arrow_upward
                        </v-icon>no conditions
                      </v-btn>
                    </template>
                  </SiConditionEditor>
                </v-flex>
                <SiConditionChips :condition="field.condition" />
              </v-layout>
            </v-flex>
            <v-flex
              xs12
              py-0
            >
              <v-autocomplete
                v-model="field.inputType"
                label="Input type"
                :items="_inputTypesItemsArr"
                outlined
                @input="save"
                @change="setItems()"
              >
                <template #selection="{ item }">
                  <v-layout
                    align-center
                    ma-0
                  >
                    <v-icon class="mr-8 ml-1">
                      {{ item.icon }}
                    </v-icon> {{ item.text }}
                  </v-layout>
                </template>
                <template #item="{ item, on }">
                  <v-list-item v-on="on">
                    <v-list-item-icon><v-icon>{{ item.icon }}</v-icon></v-list-item-icon>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-flex>
        
            <v-flex
              v-if="field.inputType === 'SiInputCalculated'"
              xs12
              py-0
            >
              <SiInputAutocomplete
                :value="field.format"
                label="Value format"
                :items="formats"
                outlined
                @change="e => {field.format = e; save()}"
              />
            </v-flex>
            <v-flex
              v-if="fieldAttrs(field.inputType).cents"
              xs12
              py-0
            >
              <SiInputSelect
                outlined
                :value="field.cents"
                label="Dollar format"
                :items="[{text: 'Whole dollars', value: false}, {text: 'Dollars with cents', value: true}]"
                @change="e => {field.cents = e; save()}"
              />
            </v-flex>
            <v-flex
              v-if="fieldAttrs(field.inputType).label"
              xs12
              py-0
            >
              <SiInputTextarea
                ref="label"
                outlined
                :value="field.label"
                label="Label"
                rows="1"
                @change="e => {field.label = e; save()}"
              />
            </v-flex>
            <v-flex
              v-if="fieldAttrs(field.inputType).reportLabel"
              xs12
              py-0
            >
              <SiInputText
                outlined
                :value="field.reportLabel"
                :label="`${field.reportHide ? 'not shown on report...' : 'Report Label'}`"
                :placeholder="field.label"
                :readonly="field.reportHide"
                :prepend-inner-icon="field.reportHide ? 'close' : ''"
                :append-icon="field.reportHide ? 'visibility_off' : 'visibility'"
                @change="e => {field.reportLabel = e; save()}"
                @click:append="toggleReportLabel"
              />
            </v-flex>
            <v-flex
              v-if="fieldAttrs(field.inputType).description"
              xs12
              py-0
            >
              <SiInputTextarea
                auto-grow
                outlined
                :value="field.description"
                label="Description"
                @change="e => {field.description = e; save()}"
              />
            </v-flex>
            <!-- <v-flex xs12 v-if="fieldAttrs(field.inputType).hint">
          <SiInputText outlined
          :value="field.hint"
          label="Hint"
          @change="e => {field.hint = e; save()}"
          />
        </v-flex> -->
            <v-flex
              v-if="fieldAttrs(field.inputType).help"
              xs12
              py-0
            >
              <SiInputTextarea
                ref="textarea"
                outlined
                :value="field.help"
                label="Help"
                rows="2"
                auto-grow
                @change="e => {field.help = e; save()}"
              />
            </v-flex>

            <v-flex
              v-if="field.inputType === 'SiAlert'"
              xs12
              py-0
            >
              <SiInputAutocomplete
                :value="field.type"
                label="Alert type"
                :items="alertTypes"
                outlined
                @change="e => {field.type = e; save()}"
              />
              <SiInputSelect
                :value="field.border"
                label="Alert border"
                :items="alertBorders"
                outlined
                @change="e => {field.border = e; save()}"
              />
              <v-layout>
                <v-flex>
                  <v-checkbox
                    outlined
                    class="mt-0"
                    :value="field.text"
                    label="Text"
                    @change="e => {field.text = e; save()}"
                  />
                </v-flex>
                <v-flex>
                  <v-checkbox
                    outlined
                    class="mt-0"
                    :value="field.outlined"
                    label="Outlined"
                    @change="e => {field.outlined = e; save()}"
                  />
                </v-flex>
              </v-layout>
              <v-layout wrap>
                <v-flex
                  xs12
                  md4
                >
                  <SiInputText
                    :value="field.linkText"
                    label="Link Text"
                    outlined
                    @change="e => {field.linkText = e; save()}"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <SiInputText
                    :value="field.link"
                    label="Link"
                    outlined
                    @change="e => {field.link = e; save()}"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <SiInputText
                    :value="field.linkButtonColor"
                    label="Link button color"
                    outlined
                    @change="e => {field.linkButtonColor = e; save()}"
                  />
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex
              v-if="fieldAttrs(field.inputType).dateMinMax"
              xs12
            >
              <v-layout wrap>
                <v-flex
                  xs12
                  sm6
                  py-0
                >
                  <SiInputText
                    outlined
                    :value="field.min"
                    label="Min Date"
                    hint="Date as ISO sting, or template literaly and access calculation data via $.cData"
                    @change="e => {field.min = e; save()}"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  py-0
                >
                  <SiInputText
                    outlined
                    :value="field.max"
                    label="Max Date"
                    hint="Date as ISO sting, or template literaly and access calculation data via $.cData"
                    @change="e => {field.max = e; save()}"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
            <!-- <v-flex xs12 py-0 v-if="fieldAttrs(field.inputType).decimals">
          <SiInputNumber outlined
          :value="field.decimals"
          label="Decimals"
          @change="e => {field.decimals = e; save()}"
          />
        </v-flex> -->

        
            <v-flex
              v-if="fieldAttrs(field.inputType).decimals || fieldAttrs(field.inputType).increment"
              xs12
            >
              <v-layout wrap>
                <v-flex
                  v-if="fieldAttrs(field.inputType).decimals"
                  xs6
                  py-0
                >
                  <SiInputNumber
                    outlined
                    :value="field.decimals"
                    label="Decimals"
                    @change="e => {field.decimals = e; save()}"
                  />
                </v-flex>
                <v-flex
                  v-if="fieldAttrs(field.inputType).increment"
                  xs6
                  py-0
                >
                  <v-text-field
                    outlined
                    :value="field.increment"
                    label="Increment"
                    :readonly="field.hideSpinner"
                    @change="e => {field.increment = e; save()}"
                  >
                    <template #append>
                      <span style="position: absolute; right: 8px; top: 14px">
                        <v-btn
                          textx
                          depressed
                          small
                          :color="field.hideSpinner ? 'light-grey' : 'primary'"
                          @click="() => {field.hideSpinner = !field.hideSpinner; save()}"
                        >
                          {{ field.hideSpinner ? 'Hidden' : 'Visible' }}
                        </v-btn>
                      </span>
                    </template>
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex
              v-if="fieldAttrs(field.inputType).minMax"
              xs12
            >
              <v-layout wrap>
                <v-flex
                  xs12
                  sm6
                  py-0
                >
                  <SiInputNumber
                    outlined
                    :value="field.min"
                    label="Min number"
                    @change="e => {field.min = e; save()}"
                  />
                </v-flex>
                <v-flex
                  xs12
                  sm6
                  py-0
                >
                  <SiInputNumber
                    outlined
                    :value="field.max"
                    label="Max number"
                    @change="e => {field.max = e; save()}"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex
              v-if="['SiInputCheckbox', 'SiInputFile'].includes(field.inputType)"
              xs12
              py-0
            >
              <!-- <SiInputSwitch outlined
          :value="field.multiple"
          :label="`${field.multiple ? 'Multiple' :  'Single'}`"
          @change="e => {field.multiple = e; save()}"
          /> -->
              <SiInputRadio
                :value="field.multiple"
                :items="[{text: 'Single', value: false}, {text: 'Multiple', value: true}]"
                @change="e => {field.multiple = e; save()}"
              />
            </v-flex>

            <v-flex
              v-if="['SiInputSelect'].includes(field.inputType)"
              xs12
              py-0
            >
              <SiInputCheckbox
                outlined
                :value="field.autoSelect"
                label="Auto select if only one option"
                @change="e => {field.autoSelect = e; save()}"
              />
            </v-flex>

            <v-flex
              v-if="fieldAttrs(field.inputType).canHaveRules"
              xs12
              py-0
            >
              <SiInputCheckbox
                outlined
                :value="field.required"
                label="Required"
                @change="e => {field.required = e; save()}"
              />
            </v-flex>

            <v-flex
              v-if="fieldAttrs(field.inputType).fields"
              xs12
              pa-0
            >
              <v-flex
                xs12
                py-0
              >
                <SiInputText
                  outlined
                  :value="field.multiNoItemsText"
                  label="No items text"
                  @change="e => {field.multiNoItemsText = e; save()}"
                />
              </v-flex>
              <v-flex
                xs12
                py-0
              >
                <SiInputText
                  outlined
                  :value="field.multiItemText"
                  label="Individual item text"
                  hint="Text used to reffer to an individual row/item"
                  apply-layout
                  @change="e => {field.multiItemText = e; save()}"
                />
              </v-flex>
              <v-flex>
                <v-layout>
                  <v-flex
                    xs6
                    py-0
                  >
                    <SiInputNumber
                      outlined
                      :value="field.multiMinRequired || 0"
                      label="Required items"
                      hint="Minimum number of required items"
                      :min="0"
                      apply-layout
                      @change="e => {field.multiMinRequired = e; save()}"
                    />
                  </v-flex>
                  <v-flex
                    xs6
                    py-0
                  >
                    <SiInputNumber
                      outlined
                      :value="field.multiMinRequired > 0 ? field.multiMinRequired : field.multiInitializeWith || 0"
                      :disabled="field.multiMinRequired > 0"
                      label="Initialize with items"
                      hint="Number of items to initialize with"
                      :min="0"
                      apply-layout
                      @change="e => {field.multiInitializeWith = e; save()}"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex
                xs12
                py-0
              >
                <SiInputRadio
                  :value="field.multiLayout"
                  label="Layout"
                  :items="[{text: 'Table', value: 'table'}, {text: 'Form', value: 'form'}]"
                  apply-layout
                  required
                  @change="e => {field.multiLayout = e; save()}"
                />
              </v-flex>
              <v-flex
                xs12
                py-0
              >
                <SiInputNumber
                  v-if="field.multiLayout === 'table'"
                  outlined
                  :value="field.multiColumns"
                  label="Table columns"
                  apply-layout
                  @change="e => {field.multiColumns = e; save()}"
                />
              </v-flex>
              <div class="v-label mb-2">
                Fields
              </div>
              <SiFieldListEditor
                v-model="field.fields"
                :fields="fields"
                :all-picked-fields="field.fields"
                @change="save"
              />
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- <v-flex xs12 v-if="fieldAttrs(field.inputType).items"> -->
        <v-flex
          v-if="hasItems"
          xs12
        >
          <v-divider />
          <SiInputSwitch
            v-model="showConditions"
            label="Show item conditions"
          />
          <v-layout v-if="field.items">
            <v-flex
              xs6
              class="caption"
            >
              Text
            </v-flex>
            <v-flex
              xs6
              class="caption"
            >
              Subtext (optional)
            </v-flex>
            <v-flex
              xs4
              class="caption"
            >
              Value
            </v-flex>
            <v-flex style="width:212px; height:10px" />
          </v-layout>
          <Container
            lock-axis="y"
            drag-handle-selector=".si-drag-handle"
            @drop="onDrop(field.name, $event)"
          >
            <Draggable
              v-for="(item, i) in field.items"
              :key="i"
            >
              <v-layout
                align-center
                my-0
              >
                <v-flex
                  xs6
                  lg4x
                >
                  <SiInputText
                    v-model="item.text"
                    outlined
                    single-line
                    hide-details
                    label="Item Text"
                    @change="save"
                  />
                </v-flex>
                <v-flex
                  xs6
                  lg4x
                >
                  <SiInputText
                    v-model="item.subtext"
                    outlined
                    single-line
                    hide-details
                    label="Item Subtext"
                    @change="save"
                  />
                </v-flex>
                <v-flex
                  xs4
                  lg4x
                >
                  <SiInputText
                    v-model="item.value"
                    outlined
                    single-line
                    hide-details
                    label="Item Value"
                    @change="save"
                    @keydown.tab="itemTab($event, field.name, i, (field.items || []).length)"
                  />
                </v-flex>
                <v-flex
                  shrink
                  pa-0
                >
                  <v-layout
                    ma-0
                    pr-2
                  >
                    <SiConditionEditor
                      v-model="item.condition"
                      :title="`<strong>${item.value}</strong> condition`"
                      :fields="fields"
                      chips-left
                      @change="save"
                    />
                  </v-layout>
                </v-flex>
                <v-flex
                  shrink
                  pa-0
                >
                  <SiDeleteButton
                    title="Remove item?"
                    message="Are you sure you want to remove this item?"
                    delete-button-text="remove"
                    :bypass-prompt="!item.value && !item.text"
                    @delete="() => removeItem(field.name, i)"
                  >
                    <template #activator="{ on }">
                      <v-btn
                        text
                        icon
                        small
                        color="grey"
                        tabindex="-1"
                        v-on="on"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </template>
                  </SiDeleteButton>
                </v-flex>
                <v-flex
                  shrink
                  class="cursor-move"
                  pa-0
                >
                  <v-icon class="mx-3 si-drag-handle">
                    drag_indicator
                  </v-icon>
                </v-flex>
              </v-layout>
              <SiConditionChips
                v-if="item.condition && showConditions"
                :condition="item.condition"
              />
            </Draggable>
          </Container>
          <v-btn
            color="primary"
            text
            class="mx-0"
            @click="addItem(field.name)"
          >
            <v-icon left>
              add
            </v-icon>Add
          </v-btn>
        </v-flex>

        <v-flex
          v-if="fieldAttrs(field.inputType).formula"
          xs12
        >
          <v-flex
            shrink
            class="caption"
          >
            <v-simple-table
              dense
              class="si-plain-table no-hover"
            >
              <tbody>
                <tr>
                  <td
                    width="10"
                    class="font-weight-bold pl-0 caption"
                  >
                    $
                  </td> <td
                    width="100%"
                    class="caption"
                  >
                    this
                  </td>
                </tr>
                <tr>
                  <td
                    width="10"
                    class="font-weight-bold pl-0 caption"
                  >
                    $.cData
                  </td> <td
                    width="10"
                    class="caption"
                  >
                    calculation data object
                  </td> <td width="100%" />
                </tr>
                <tr>
                  <td
                    width="10"
                    class="font-weight-bold pl-0 caption"
                  >
                    $[function]
                  </td> <td
                    width="10"
                    class="caption"
                  >
                    external library i.e. $.moment
                  </td> <td width="100%" />
                </tr>
                <tr>
                  <td
                    width="10"
                    class="font-weight-bold pl-0 caption"
                  >
                    row
                  </td> <td
                    width="10"
                    class="caption"
                  >
                    field's row data if it is in multi item
                  </td> <td width="100%" />
                </tr>
                <tr>
                  <td
                    width="10"
                    class="font-weight-bold pl-0 caption"
                  >
                    rows
                  </td> <td
                    width="10"
                    class="caption"
                  >
                    rows data if field is in multi item
                  </td> <td width="100%" />
                </tr>
                <tr>
                  <td
                    width="10"
                    class="font-weight-bold pl-0 caption"
                  >
                    index
                  </td> <td
                    width="10"
                    class="caption"
                  >
                    row index of field if it is in multi item
                  </td> <td width="100%" />
                </tr>
              </tbody>
            </v-simple-table>
          </v-flex>
          <SiCodeEditor
            :value="field.formula"
            @commit="commitFormula"
          />
        </v-flex>

        <v-flex
          v-if="fieldAttrs(field.inputType).canHaveRules"
          xs12
        >
          <SiInputCheckbox
            v-model="field.moreRules"
            outlined
            hide-details
            label="Custom Validation"
            @change="save"
          />
        </v-flex>

        <v-flex
          v-if="field.moreRules && fieldAttrs(field.inputType).canHaveRules"
          xs12
        >
          <v-flex
            shrink
            class="caption"
          >
            <v-simple-table
              dense
              class="si-plain-table no-hover"
            >
              <tbody>
                <tr>
                  <td
                    width="10"
                    class="font-weight-bold pl-0 caption"
                  >
                    $
                  </td> <td
                    width="100%"
                    class="caption"
                  >
                    this
                  </td>
                </tr>
                <tr>
                  <td
                    width="10"
                    class="font-weight-bold pl-0 caption"
                  >
                    $.cData
                  </td> <td
                    width="10"
                    class="caption"
                  >
                    calculation data object
                  </td> <td width="100%" />
                </tr>
                <tr>
                  <td
                    width="10"
                    class="font-weight-bold pl-0 caption"
                  >
                    $[function]
                  </td> <td
                    width="10"
                    class="caption"
                  >
                    external library i.e. $.moment
                  </td> <td width="100%" />
                </tr>
                <tr>
                  <td
                    width="10"
                    class="font-weight-bold pl-0 caption"
                  >
                    row
                  </td> <td
                    width="10"
                    class="caption"
                  >
                    field's row data if it is in multi item
                  </td> <td width="100%" />
                </tr>
                <tr>
                  <td
                    width="10"
                    class="font-weight-bold pl-0 caption"
                  >
                    rows
                  </td> <td
                    width="10"
                    class="caption"
                  >
                    rows data if field is in multi item
                  </td> <td width="100%" />
                </tr>
                <tr>
                  <td
                    width="10"
                    class="font-weight-bold pl-0 caption"
                  >
                    index
                  </td> <td
                    width="10"
                    class="caption"
                  >
                    row index of field if it is in multi item
                  </td> <td width="100%" />
                </tr>
              </tbody>
            </v-simple-table>
          </v-flex>
          <SiCodeEditor
            :value="field.rules"
            @commit="commitRules"
          />
        </v-flex>

        <v-flex
          xs12
          text-center
        >
          <SiDeleteButton
            title="Delete Field?"
            :message="`Are you certain you want to delete <strong>${field.name}</strong>? If this field is used in a calculation deleting it will cause the calculation to fail.`"
            :challenge="field.name"
            @delete="deleteField(field.name)"
          >
            <template #activator="{ on }">
              <v-btn
                text
                color="grey"
                v-on="on"
              >
                Delete Field
              </v-btn> 
            </template>
          </SiDeleteButton>
        </v-flex>
      </v-layout>
    </v-container>
    <v-progress-linear
      :indeterminate="true"
      :active="saveActive"
      class="ma-0"
      height="2"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Container, Draggable } from 'vue-smooth-dnd'
import { rtdb } from '@/plugins/firebase'
import helpers from '@/mixins/helpers'
import conditions from '@/mixins/conditions'
import drag from '@/mixins/drag'

export default {
  components: {
    Container,
    Draggable
  },
  mixins: [helpers, conditions, drag],
  props: {
    value: Object,
    fields: Object,
    calculatorId: String
  },
  data () {
    return {
      // formula: this.value.formula,
      // rules: this.value.rules,
      field: this.value,
      showConditions: false,
      saveTimeout: null,
      saveFunction: null,
      savePending: false,
      saveActive: false,
      alertTypes: [
        { text: 'Info', value: 'info' },
        { text: 'Warning', value: 'warning' },
        { text: 'Success', value: 'success' },
        { text: 'Error', value: 'error' },
        { text: 'Primary', value: 'primary' }
      ],
      alertBorders: [
        { text: 'None', value: null },
        { text: 'Left', value: 'left' },
        { text: 'Right', value: 'right' },
        { text: 'Top', value: 'top' },
        { text: 'Bottom', value: 'bottom' },
      ],
      alertOptions: [
        { text: 'Text', value: 'text:true' },
        { text: 'Outlined', value: 'outlined:true' },
      ],
      formats: [
        { text: 'Text', value: 'text' },
        { text: 'Number', value: 'number' },
        { text: 'Currency', value: 'currency' },
        { text: 'Percent', value: 'percent' },
        { text: 'Date', value: 'date' },
        { text: 'Boolean', value: 'boolean' }
      ]
    }
  },
  computed: {
    ...mapGetters(['_inputTypes', '_inputTypesItemsArr']),
    fieldPath () {
      return `calculators/${this.calculatorId}/structure/fields/${this.field.name}`
    },
    hasItems () {
      return this.field.inputType === 'input_checkbox'
        ? this.field.multiple
        : ((this._inputTypes[this.field.inputType] || {}).attrs || {}).items
    }
  },
  watch: {
    value (v) {
      this.field = v
      this.formula = this.field.formula
    },
    'field.inputType' (v) {
      this.setFormulaValue()
      this.setDefaults(v)
      this.$nextTick(() => {
        this.$refs.label.focus()
      })
    },
    'field.moreRules' (v) {
      if (!v) {
        this.field.rules = ''
        this.save()
      }
    }
  },
  beforeMount () {
    this.setFormulaValue()
  },
  methods: {
    save () {
      if (!this.$route.query.fieldId) return

      this.savePending = true

      if (this.field.items) {
        this.field.items.forEach(item => {
          if (item.value === 'true') item.value = true
          if (item.value === 'false') item.value = false
        })
      }
      if (this.field.inputType !== 'calculated') {
        this.field.format = this._inputTypes[this.field.inputType].format
      }

      let field = this._removeUndefined(this.field)
      rtdb.ref(this.fieldPath).set(field, () => {
        this.savePending = false
        setTimeout(() => {
          this.saveActive = false
        }, 500)
      })
    },
    deleteField () {
      rtdb.ref(this.fieldPath).remove()
      this.$emit('close')
    },
    setItems () {
      if (this.hasItems) {
        if (!this.field.items && this.field.inputType === 'input_radio') {
          this.field.items = [{
            text: 'Yes',
            value: true
          }, {
            text: 'No',
            value: false
          }]
        }
        if (!this.field.items) {
          this.field.items = [{
            text: '',
            value: ''
          }]
        }
      } else {
        this.field.items = null
      }
    },
    fieldAttrs (type) {
      return (this._inputTypes[type] || {}).attrs || {}
    },
    toggleReportLabel () {
      this.$set(this.field, 'reportHide', !this.field.reportHide)
      this.save(true)
    },
    itemTab (e, fieldName, i, listLength) {
      if (e.shiftKey) return
      if (i < listLength - 1) return
      this.addItem(fieldName)
    },
    addItem (fieldName, run = true) {
      if (!run) return
      var item = {
        value: '',
        text: ''
      }
      let field = this.fields[fieldName]
      if (!field.items) this.$set(field, 'items', [])
      field.items.push(item)
      this.save()
    },
    removeItem (fieldName, i) {
      let field = this.fields[fieldName]
      field.items.splice(i, 1)
      this.save()
    },
    onDrop (fieldName, dropResult) {
      let field = this.fields[fieldName]
      field.items = this._applyDrag(field.items, dropResult)
      this.save()
    },
    setFormulaValue () {
      if (this.field.inputType === 'calculated') {
        if (!this.field.formula) this.field.formula = ''
      } else {
        this.$delete(this.field, 'forumla')
      }
    },
    commitFormula (code) {
      this.field.formula = code
      this.save(true)
    },
    commitRules (code) {
      this.field.rules = code
      this.save(true)
    },
    setDefaults (inputType) {
      switch (inputType) {
        case 'SiInputCurrency':
          this.$set(this.field, 'cents', true)
          break
      
        default:
          this.$delete(this.field, 'cents')
          break
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
